import script from "./ServicesBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./ServicesBlock.vue?vue&type=script&setup=true&lang=js"

import "./ServicesBlock.vue?vue&type=style&index=0&id=03cf412b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03cf412b"]])

export default __exports__